/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * {
     * "optionId": "150",
     * "label": "150 miles or less"
     * },
     * {
         * "optionId": "300",
         * "label": "151-300 miles"
         * },
         * {
             * "optionId": "500",
             * "label": "301-500 miles"
             * },
             * {
                 * "optionId": "1000",
                 * "label": "501-1,000 miles"
                 * },
                 * {
                     * "optionId": "1000PLUS",
                     * "label": "+1,001 miles"
                     * }
                     */
export var AverageRadiusEnum;

(function (AverageRadiusEnum) {
  AverageRadiusEnum["_150"] = "150";
  AverageRadiusEnum["_300"] = "300";
  AverageRadiusEnum["_500"] = "500";
  AverageRadiusEnum["_1000"] = "1000";
  AverageRadiusEnum["_1000PLUS"] = "1000PLUS";
})(AverageRadiusEnum || (AverageRadiusEnum = {}));